import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { ACHILLES_EFAKTUR_DOWNLOAD_PATH } from './components/efaktur-download-page/services/customization.service';
import CustomEfakturDownloadPage from './components/efaktur-download-page/custom-efaktur-download-page';
import AchillesEfakturDownloadPage from './components/efaktur-download-page/achilles-efaktur-download-page';
import NpwpCollectorPage from './components/npwp-collector-page/npwp-collector-page';

function AppRouteSwitch() {
  return (
    <Switch>
      <Route exact={true} path={ACHILLES_EFAKTUR_DOWNLOAD_PATH} component={AchillesEfakturDownloadPage} />

      <Route exact={true} path="/vendor/:vendorEmail/:vendorToken/:opBuyerCompanyId" component={NpwpCollectorPage} />
      <Route exact={true} path="/efaktur/:customerPrefix" component={CustomEfakturDownloadPage} />
      <Route path="*">
        <Redirect to={ACHILLES_EFAKTUR_DOWNLOAD_PATH} />
      </Route>
    </Switch>
  );
}

export default AppRouteSwitch;
